var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9579 2.98602H19.0634C20.2262 2.98602 21.1689 3.92867 21.1689 5.0915V19.128C21.1689 20.2909 20.2262 21.2335 19.0634 21.2335H2.21956C1.05673 21.2335 0.114075 20.2909 0.114075 19.128V5.0915C0.114075 3.92867 1.05673 2.98602 2.21955 2.98602H4.32503V0.178711H5.72869V2.98602H15.5543V0.178711H16.9579V2.98602ZM8.53599 11.4079H4.32503V10.0043H8.53599V11.4079ZM16.9579 10.0043H12.747V11.4079H16.9579V10.0043ZM8.53599 15.6189H4.32503V14.2152H8.53599V15.6189ZM12.747 15.6189H16.9579V14.2152H12.747V15.6189Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignSettings);
export default __webpack_public_path__ + "static/media/campaignSettings.a70020d24f29523557c1ba9f2386f496.svg";
export { ForwardRef as ReactComponent };